import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { forwardRef } from 'react';
import { cn } from '@/utils/cn';

const TooltipProvider = TooltipPrimitive.Provider;
const TooltipArrow = TooltipPrimitive.Arrow;

const Tooltip = ({ ...props }) => <TooltipPrimitive.Root {...props} />;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = forwardRef(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      "z-50 overflow-hidden rounded-md px-3 py-1.5 text-sm bg-black/90 text-white animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
      className
    )}
    {...props}
  />
));

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider, TooltipArrow }; 